import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=0f607510"
import script from "./employeeDetail.vue?vue&type=script&lang=js"
export * from "./employeeDetail.vue?vue&type=script&lang=js"
import style0 from "./employeeDetail.vue?vue&type=style&index=0&id=0f607510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports